// WEB2 · Вход по коду / ссылке. Поле «Код матча» (6 символов, напр. A7K32Q) ИЛИ вставка
// ссылки → «Открыть табло» (переход на WEB1 по ?code=<shareId>). Под формой — пример-карточка
// живого матча. Пустой/некорректный ввод не открывает табло (показывает подсказку).
// Только просмотр: никаких элементов управления счётом.

import { extractShareIdFromInput, isValidCode } from './view';

const LOGO_SVG = `<span class="logo"><span class="logo__ring"></span></span>`;
const LOCK_SVG = `<svg viewBox="0 0 24 24" class="ico" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>`;
const ARROW_SVG = `<svg viewBox="0 0 24 24" class="ico" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>`;

export interface EntryOptions {
  /** Куда перейти при валидном вводе. По умолчанию — навигация на ?code=<id>. */
  onOpen?: (shareId: string) => void;
}

export class Entry {
  private root: HTMLElement;
  private input!: HTMLInputElement;
  private hint!: HTMLElement;
  private opts: EntryOptions;

  constructor(root: HTMLElement, opts: EntryOptions = {}) {
    this.root = root;
    this.opts = opts;
  }

  mount(): void {
    this.root.innerHTML = this.markup();
    this.input = this.root.querySelector('[data-code-input]') as HTMLInputElement;
    this.hint = this.root.querySelector('[data-hint]') as HTMLElement;
    const form = this.root.querySelector('[data-entry-form]') as HTMLFormElement;
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.submit();
    });
    this.input.addEventListener('input', () => {
      this.hint.classList.remove('is-error');
      this.hint.textContent = 'или вставьте ссылку antscore.dev.pl.webant.ru/?share=…';
    });
  }

  private submit(): void {
    const raw = this.input.value;
    const shareId = extractShareIdFromInput(raw);
    if (!shareId) {
      this.hint.textContent = 'Введите корректный 6-символьный код (напр. A7K32Q) или ссылку на табло';
      this.hint.classList.add('is-error');
      this.input.focus();
      return;
    }
    if (this.opts.onOpen) {
      this.opts.onOpen(shareId);
    } else {
      // Открыть WEB1 по коду в том же окне.
      window.location.search = `?code=${encodeURIComponent(shareId)}`;
    }
  }

  /** Чистая проверка для тестов/внешнего использования. */
  static canOpen(raw: string): boolean {
    return extractShareIdFromInput(raw) !== null || isValidCode(raw);
  }

  private markup(): string {
    return `
      <div class="entry-host" data-screen="entry">
        <div class="entry-card">
          <div class="entry-brand">${LOGO_SVG}<span class="entry-brand__name">AntScore</span></div>
          <div class="entry-title">Открыть табло</div>
          <div class="entry-lead">Введите код матча или вставьте ссылку, чтобы смотреть счёт в реальном времени.</div>
          <form data-entry-form>
            <label class="entry-field">
              ${LOCK_SVG}
              <input data-code-input type="text" inputmode="text" autocomplete="off"
                     spellcheck="false" maxlength="40" placeholder="A7K32Q"
                     aria-label="Код матча или ссылка" />
              <span class="entry-field__hint">· код матча</span>
            </label>
            <div class="entry-hint" data-hint>или вставьте ссылку antscore.dev.pl.webant.ru/?share=…</div>
            <button class="entry-btn" type="submit">${ARROW_SVG}Открыть табло</button>
          </form>
          <div class="entry-sep"><span>пример матча</span></div>
          <div class="entry-example">
            <div class="entry-example__head">
              <span class="entry-example__court">Клубный корт 3</span>
              <span class="wb-live"><span class="wb-live__dot"></span>LIVE</span>
            </div>
            <div class="entry-example__row entry-example__row--a">
              <span class="entry-example__chip entry-example__chip--a"></span>
              <span class="entry-example__name">Синие</span>
              <span class="entry-example__sg">1·4</span>
              <span class="entry-example__pt entry-example__pt--a">40</span>
            </div>
            <div class="entry-example__row entry-example__row--b">
              <span class="entry-example__chip entry-example__chip--b"></span>
              <span class="entry-example__name">Красные</span>
              <span class="entry-example__sg">0·2</span>
              <span class="entry-example__pt entry-example__pt--b">30</span>
            </div>
          </div>
        </div>
      </div>
    `;
  }
}
